"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToTopButton = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const icon_names_1 = require("@/components/common/icon/icon-names");
const icon_button_styles_1 = require("@/components/common/icon-button/icon-button.styles");
const icon_button_utils_1 = require("@/components/common/icon-button/icon-button.utils");
const shared_styles_1 = require("@/stylesheets/shared.styles");
let ToTopButton = class ToTopButton extends lit_1.LitElement {
    render() {
        return (0, icon_button_utils_1.renderIconAction)({
            icon: icon_names_1.ICON_NAMES.SCROLL_TOP,
            ariaLabel: '맨 위로',
            onClick: this.handleClick,
        });
    }
    handleClick() {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }
};
ToTopButton.styles = [shared_styles_1.resetStyles, icon_button_styles_1.iconButtonStyles, icon_button_styles_1.iconButtonSecondarySkinStyles];
ToTopButton = __decorate([
    (0, decorators_js_1.customElement)('mm-to-top-button')
], ToTopButton);
exports.ToTopButton = ToTopButton;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidG8tdG9wLWJ1dHRvbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbInRvLXRvcC1idXR0b24udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBQUEsNkJBQWdDO0FBQ2hDLHFEQUFpRDtBQUVqRCxvRUFBZ0U7QUFDaEUsMkZBRzJEO0FBQzNELHlGQUFvRjtBQUNwRiwrREFBeUQ7QUFHbEQsSUFBTSxXQUFXLEdBQWpCLE1BQU0sV0FBWSxTQUFRLGdCQUFVO0lBR3pDLE1BQU07UUFDSixPQUFPLElBQUEsb0NBQWdCLEVBQUM7WUFDdEIsSUFBSSxFQUFFLHVCQUFVLENBQUMsVUFBVTtZQUMzQixTQUFTLEVBQUUsTUFBTTtZQUNqQixPQUFPLEVBQUUsSUFBSSxDQUFDLFdBQVc7U0FDMUIsQ0FBQyxDQUFBO0lBQ0osQ0FBQztJQUVPLFdBQVc7UUFDakIsTUFBTSxDQUFDLFFBQVEsQ0FBQyxFQUFFLEdBQUcsRUFBRSxDQUFDLEVBQUUsUUFBUSxFQUFFLFFBQVEsRUFBRSxDQUFDLENBQUE7SUFDakQsQ0FBQzs7QUFaTSxrQkFBTSxHQUFHLENBQUMsMkJBQVcsRUFBRSxxQ0FBZ0IsRUFBRSxrREFBNkIsQ0FBQyxDQUFBO0FBRG5FLFdBQVc7SUFEdkIsSUFBQSw2QkFBYSxFQUFDLGtCQUFrQixDQUFDO0dBQ3JCLFdBQVcsQ0FjdkI7QUFkWSxrQ0FBVyJ9